"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFocused;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useFocused(_ref) {
  var focused = _ref.focused,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focusedState = _useState2[0],
      setFocusedState = _useState2[1];

  var handleFocus = (0, _react.useCallback)(function (evt) {
    if (onFocus) onFocus(evt);
    setFocusedState(true);
  }, [onFocus]);
  var handleBlur = (0, _react.useCallback)(function (evt) {
    if (onBlur) onBlur(evt);
    setFocusedState(false);
  }, [onBlur]);
  return {
    focused: focused != null ? focused : focusedState,
    onFocus: focusedState ? onFocus : handleFocus,
    onBlur: focusedState ? handleBlur : onBlur
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/hooks/useFocused.js
// module id = 410
// module chunks = 209 210 211 212